export class GetDataPrediccionVsRealGraph {
  static readonly type =
    '[desviationPrediction] Get data Prediccion VS Real Graph';
  constructor(public payload: any) {}
}

export class GetDataErrorAbsolute {
  static readonly type = '[desviationPrediction] Get data Error Absolute';
  constructor(public payload: any) {}
}

export class GetDataDesviacionVSModelo {
  static readonly type =
    '[desviationPrediction] Get data Desviacion VS Modelo Aplicado';
  constructor(public payload: any) {}
}
